let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("UvuXg")).then(() => parcelRequire('31JhY'));